module.exports = "<ul id=\"shortcuts\" *ngIf=\"menuService.shortcuts\">\n    <li *ngFor=\"let item of menuService.shortcuts\" class=\"{{ item['cssClass'] }}\">\n        <a (click)=\"select(item)\">\n            <i *ngIf=\"item['icon']\" class=\"icon\">{{ item['icon'] }}</i>\n            <span *ngIf=\"item['title']\">{{ item['title'] | translate }}</span>\n        </a>\n    </li>\n\n    <li>\n        <i class=\"icon\" style=\"visibility: hidden;\">left</i>\n    </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/public/public-menu.component.html
// module id = 568
// module chunks = 0